module.exports = __webpack_public_path__ + "static/black1-ae224a372dde6e82e1fc64e70a043030.png";